"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupShadowDom = exports.setupOverwrittenTheme = exports.deleteSliderDotsStyles = void 0;
var _constants = require("./constants");
var _r10SourceLibrary = require("r10-source-library");
var _logger = require("../services/logger");
const deleteSliderDotsStyles = () => {
  const styleTags = document.getElementsByTagName('style');
  for (const styleTag of Array.from(styleTags)) {
    if (styleTag.textContent.match(/(?=(\.slick-dots\n{\n.*position:\sabsolute;\n\s*bottom:\s-25px;\n))/gm)) {
      _logger.Logger.info({
        segments: [_logger.Logger.LOGGER_SEGMENTS.UTILS]
      })('Removing slick dot styles');
      styleTag.remove();
    }
  }
};
exports.deleteSliderDotsStyles = deleteSliderDotsStyles;
const setupShadowDom = () => {
  const appRoot = document.getElementById(_constants.APP_ROOT_ID);
  const shadowAppRoot = appRoot.shadowRoot;
  const styleSlot = shadowAppRoot.getElementById(_constants.APP_SHADOW_DOM_STYLES_SLOT_ID);
  const enterPointStyle = document.createElement('style');
  enterPointStyle.setAttribute('data-meta', 'gs-app');
  enterPointStyle.innerHTML = `
    #gs-app-shadow > div.gs-app {
      position: relative;
      z-index: 4;
    } 
  `;
  styleSlot.append(enterPointStyle);
  // Move generated styles from head to shadow root (this for sliders)
  const headStylesLinks = document.head.querySelector('[data-meta="gs-app"]');
  if (headStylesLinks) {
    const remoteStyles = document.createElement('style');
    remoteStyles.setAttribute('type', 'text/css');
    remoteStyles.setAttribute('data-meta', 'remote-styles');
    const importUrl = headStylesLinks.getAttribute('href');
    remoteStyles.innerHTML = `@import "${importUrl}";`;
    styleSlot.append(remoteStyles);
  } else {
    const headStyles = document.head.querySelectorAll('style');
    const stylesLink = document.head.querySelector('[href^="/guidedSelling.css"]');
    if (stylesLink) styleSlot.append(stylesLink);
    headStyles.forEach(style => {
      style.setAttribute('data-meta', 'head-styles');
      styleSlot.append(style);
    });
  }
  return styleSlot;
};
exports.setupShadowDom = setupShadowDom;
const setupOverwrittenTheme = overwrittenTheme => {
  const {
    primaryColor,
    secondaryColor,
    focusColor,
    isDefaultIconColor,
    ...themeAppearance
  } = overwrittenTheme;
  _r10SourceLibrary.themeWS10.color = {
    ..._r10SourceLibrary.themeWS10.color,
    primary1: {
      ..._r10SourceLibrary.themeWS10.color.primary1,
      default: secondaryColor ? _r10SourceLibrary.themeWS10.color.primary1.default : primaryColor
    },
    secondary1: {
      ..._r10SourceLibrary.themeWS10.color.secondary1,
      default: secondaryColor || primaryColor
    },
    focus: {
      ..._r10SourceLibrary.themeWS10.color.focus,
      default: focusColor || primaryColor
    }
  };
  if (themeAppearance) _r10SourceLibrary.themeWS10.localThemes = themeAppearance;
  // apply icons theme colors
  const systemIconsRules = _r10SourceLibrary.themeWS10.getIconProperties('system');
  _r10SourceLibrary.themeWS10.setIconGroup('system', 'SourceSystemIcons', () => {
    return {
      ...systemIconsRules,
      appearance: {
        ...systemIconsRules.appearance,
        primary: {
          color: isDefaultIconColor ? systemIconsRules.appearance.primary.color : primaryColor
        }
        //We don't pass an inverse but it is required by type, ought to investigate if you should pass it
      }
    };
  });

  if (themeAppearance.fontFamily) _r10SourceLibrary.themeWS10.baseFont.fontFamily = themeAppearance.fontFamily;
};
exports.setupOverwrittenTheme = setupOverwrittenTheme;